import { useEffect } from "react";
import { useSelector } from "react-redux";

export const TextSizeApplier = () => {
  const stateTextSize = useSelector((state: any) => state.textSize.value)
  
  useEffect(() => {
    document.documentElement.setAttribute("data-text-size", stateTextSize);
  }, [stateTextSize]);

  return null;
};